// THE GROUND INDEX OP (quest-move 2026-11-02, client/src/pool.js): one GM03
// L0 node decoded + indexed on the worker's own vrm_core instance — the work
// ClientGround's synchronous gm.add did on the main thread (11-50 ms a node on
// the box, a gap per crossed node while flying) — and handed back as its
// GMIX1 index (vrm_core/wasm gmix: the key, the mesh and the bucket grid, every
// number as its own bits), which the main thread's Ground adopts whole
// (Ground.addIndex, ~1 ms): the node gm.add would have built, bit for bit
// (check-vrm-core §7b). Pure: the job carries the bytes, the artefact's
// exports come as ctx.wasm (poolwork.js).
//
//   ground.index {ab: ArrayBuffer GM03}  (wasm 'vrm_core') -> {ix: ArrayBuffer GMIX1}
import { fromExports } from '../../vrm_core/js/vrm_core.mjs';

const _cores = new WeakMap();      // instance exports -> the glue's Core (one per worker instance)
function coreOf(e) {
  let c = _cores.get(e);
  if (!c) _cores.set(e, c = fromExports(e));
  return c;
}

export const GROUND_OPS = {
  'ground.index': ({ ab }, ctx) => {
    if (!ctx.wasm) throw new Error('ground.index: no wasm artefact on the job');
    const ix = coreOf(ctx.wasm).indexNode(new Uint8Array(ab));
    return { result: { ix: ix.buffer }, transfer: [ix.buffer] };
  },
};
